import { useEffect } from 'react';

export default function usePageMeta(title, description, noindex = false) {
  useEffect(() => {
    if (title) document.title = title;
    const desc = document.querySelector('meta[name="description"]');
    if (description && desc) desc.setAttribute('content', description);
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute('content', noindex ? 'noindex, nofollow' : 'index, follow');
  }, [title, description, noindex]);
}
